import styled from 'styled-components';

export const TopbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.white};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`;

const BaseIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease;
  align-items: center;

`; 

export const ButtonMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

`;

export const ActionButton = styled(BaseIconButton)`
  padding: 8px;
  cursor: pointer;
`;

export const CloseButton = styled(BaseIconButton)`
  padding: 4px;
`;
